import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeleteHotelExtra as forceDeleteHotelExtraAPI } from "../../api/apiHotelExtras";
import parseError from "../../utils/parseError";

const useForceDeleteHotelExtra = () => {
    const queryClient = useQueryClient();

    const { mutate: forceDelete, isPending: isForceDelete } = useMutation({
        mutationFn: forceDeleteHotelExtraAPI,
        onSuccess: (res) => {
            const message = res?.message || "Hotel extra permanently deleted";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["hotelExtras"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to permanently delete hotel extra");
        },
    });

    return { forceDeleteHotelExtra: forceDelete, isForceDelete };
};

export default useForceDeleteHotelExtra;
